import React from 'react'
import PropTypes from 'prop-types'

import {
  ImageUtil
} from '../../../utils';

const ImageUploadComponent = ({
  style,
  input_style,
  label,
  type,
  placeholder,
  name,
  value,
  onChange,
  required,
  hidden,
  disabled,
  display,
  image_src,
  onFileChangeHandler,
}) => {
  if (hidden) return null; // If hidden, do not render the component

  return (
    <>{display ?
      <div className={`${style}`} >
        {label !== "" &&
          <label htmlFor={name} className="form-label" >
            {required && <span className="text-danger"> * </span>}{label}
          </label>
        }
        <label htmlFor={name} style={{ cursor: 'pointer' }}>
          <img
            alt="Uploaded"
            className="rounded-full"
            style={{
              width: '220px',
              height: '220px',
              boxShadow: '3px 7px 5px -2px rgba(97, 93, 97, 0.69)',
              objectFit: 'cover'
            }}
            src={image_src || ImageUtil.uploadImage}
          />
          <input
            type="file"
            style={{ display: 'none' }}
            id={name}
            name={name}
            accept="image/*"
            onChange={onFileChangeHandler}
          />
        </label>
      </div>
      :
      <div className={`${style}`} >
        <div className="flex">
          {label !== "" &&
            <div className={`col-md-3`} >
              <label
                className="form-label"
                htmlFor={name}
              >
                {required && <span className="text-danger"> * </span>}{label}
              </label>
            </div>
          }
          <div className={`col-md-9`} >
            <label htmlFor={name} style={{ cursor: 'pointer' }}>
              <img
                alt="Uploaded"
                className="rounded-full"
                style={{
                  width: '220px',
                  height: '220px',
                  boxShadow: '3px 7px 5px -2px rgba(97, 93, 97, 0.69)',
                  objectFit: 'cover'
                }}
                src={image_src || ImageUtil.uploadImage}
              />
              <input
                type="file"
                style={{ display: 'none' }}
                id={name}
                name={name}
                accept="image/*"
                onChange={onFileChangeHandler}
              />
            </label>
          </div>
        </div>
      </div>
    }
    </>
  )
}

ImageUploadComponent.propTypes = {
  style: PropTypes.string,
  input_style: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  display: PropTypes.bool,
  image_src: PropTypes.string, // Made optional
  onFileChangeHandler: PropTypes.func.isRequired,
}

export default ImageUploadComponent
